import { Component, OnInit, ViewChild } from '@angular/core';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { ActivatedRoute, Router } from '@angular/router';
import { GroupHasRoleInOrganisationService } from '@services/groups/group-has-role-in-organisation.service';
import { GroupHasSecuredAppService } from '@services/groups/group-has-secured-app.service';
import { OrganisationService } from '@services/organisations/organisation.service';
import { PackageService } from '@services/packages/package.service';

import * as _ from 'lodash';
import { Models } from '@ibexfusion/models';
import { DataTableComponent } from '../../../components/data-table/data-table.component';
import { MatDialog } from '@angular/material/dialog';
import { PackageInstalledAppSelectionComponent } from './package-installed-app-selection/package-installed-app-selection.component';
import { PackageInstalledAppsService } from '@services/packages/package-installed-apps.service';
import { GroupService } from '@services/groups/group.service';

@Component({
    selector: 'app-group-secured-app-manager',
    templateUrl: './group-secured-app-manager.component.html',
    styleUrls: ['./group-secured-app-manager.component.scss'],
    providers: [GroupHasRoleInOrganisationService, GroupHasSecuredAppService, OrganisationService, PackageService, PackageInstalledAppsService, GroupService],
    standalone: false
})
export class GroupSecuredAppManagerComponent implements OnInit {

  @ViewChild(DataTableComponent) table: DataTableComponent;

  title = 'Group Has Secured App Management';
  dataProviderParams: any;
  columns = [{ prop: 'title' }, { prop: 'packageInstalledAppId' }];
  tableData = [];
  pageActions: PageAction[];

  validRole = false;
  selectedGroupId: string;

  packageIds = [];
  assignedPackageInstalledApps = []

  constructor(
    private dialog: MatDialog, private route: ActivatedRoute, private groupHasRolesInOrganisationsService: GroupHasRoleInOrganisationService,
    private groupHasSecuredAppService: GroupHasSecuredAppService, private organisationService: OrganisationService, private packageService: PackageService, private router: Router,
    private packageAppService: PackageInstalledAppsService, private groupService: GroupService
  ) {
  }

  ngOnInit() {
    this.selectedGroupId = this.route.snapshot.params['id'];
    this.groupService.get(this.selectedGroupId).then(group => {
      this.title = !!group ? 'Manage Secured Content of Group: ' + group.name : this.title;
    });
    this.groupHasRolesInOrganisationsService.find(0, 100, { GroupID: this.selectedGroupId }).then(result => {
      result.data.map(ghr => {
        if (ghr.roleName === 'securedContent') {
          this.validRole = true;
          this.organisationService.get(ghr.OrganisationID).then(org => {
            if (!org) { return; }
            this.packageService.find(0, 100, { customerId: org.organisationCustomerId }).then(packages => {
              this.packageIds = _.map(packages.data, '_id');
            });
          })
        }
      })
    });
    this.initTableData();
    this.createPageActions();
  }

  initTableData() {
    this.tableData = [];
    this.assignedPackageInstalledApps = [];
    this.groupHasSecuredAppService.find(0, 100, { Groups_GroupID: this.selectedGroupId }).then(contents => {
      this.packageAppService.find(0, 100, {_id: { $in: contents.data.map(element => { return element.packageInstalledAppId }) }}).then(apps => {
        this.tableData = contents.data;
        for (let i = 0; i < this.tableData.length; i++) {
          if (_.findIndex(apps.data, { _id: this.tableData[i].packageInstalledAppId } ) > -1) {
            this.tableData[i]['title'] = apps.data[_.findIndex(apps.data, { _id: this.tableData[i].packageInstalledAppId } )].translations[0].appTitle;
          } else {
            this.tableData[i]['title'] = '';
          }
        }
        this.assignedPackageInstalledApps = _.map(contents.data, 'packageInstalledAppId');
      });
    })
  }

  addContent() {
    const dialogRef = this.dialog.open(PackageInstalledAppSelectionComponent, {
      width: '800px',
      data: {
        packageIds: this.packageIds,
        assignedPackageInstalledApps: this.assignedPackageInstalledApps
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result._id) {
        const data = new Models.GroupHasSecuredApp();
        data.populateFromJSON({
          Groups_GroupID: this.selectedGroupId,
          packageInstalledAppId: result._id
        });
        this.groupHasSecuredAppService.create(data).then(() => {
          this.initTableData();
          this.table.refresh();
        });
      }
    })
  }

  onDelete(event: any) {
    this.groupHasSecuredAppService.remove(event.row.GroupHasSecuredAppID).then(() => {
      this.initTableData();
      this.table.refresh();
    });
  }

  createPageActions() {
    this.pageActions = [
      new PageAction({
        icon: 'subdirectory_arrow_left',
        title: 'Detail',
        callback: () => {
          this.router.navigate(['groups', this.route.snapshot.params['id']]);
        }
      })
    ];
  }
}
